import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMailsent = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M23 14.8252L15.8252 22L11.7998 17.9746L12.875 16.9004L15.8252 19.8496L21.9248 13.75L23 14.8252ZM20.4248 4C20.8414 4 21.1957 4.1459 21.4873 4.4375C21.779 4.72917 21.9248 5.08333 21.9248 5.5V11.5996L15.7754 17.75L12.875 14.8496L9.7002 18.0254L11.4004 19.7002H3.5C3.08338 19.7002 2.72915 19.5543 2.4375 19.2627C2.14588 18.9711 2.00005 18.6168 2 18.2002V5.5C2 5.08333 2.14583 4.72917 2.4375 4.4375C2.72917 4.14583 3.08333 4 3.5 4H20.4248ZM11.9502 10.8252L3.59961 5.5L3.5 6.90039L11.9502 12.3252L20.4248 6.90039L20.2998 5.5L11.9502 10.8252Z",
		fill: "#8D8D92"
	})
});
export default SvgMailsent;
